<template>
  <div></div>
</template>

<script>
import { isIOS } from "@/utils/isIphoneX";

export default {
  name: "Share",
  data() {
    return {
      iosUrl: `${process.env.VUE_APP_DOMAIN}/install?code=${this.$route.query.code}`,
      androidUrl: process.env.VUE_APP_DOMAIN
    };
  },
  created() {
    if (isIOS) {
      window.location.replace(this.iosUrl);
    } else {
      window.location.replace(this.androidUrl);
    }
  }
};
</script>

<style lang="scss" scoped></style>
